import { useEffect } from 'react';
import { useModalContext } from 'src/hooks/useModalContext';

export const useSaveOpenedModal = () => {
  const { openedModalName } = useModalContext();

  useEffect(() => {
    if (!openedModalName) {
      localStorage.removeItem('openedModalName');
      return;
    }
    localStorage.setItem('openedModalName', openedModalName);
  }, [openedModalName]);
};
